import {
  AnalyticsApplicationData,
  AnalyticsEventData,
  ApplicationData,
} from '../../service/piano-analytics';
import { eventClick } from './common';

export const APP_DATA: AnalyticsApplicationData = {
  application_id: 'device_registration_rabo_scanner',
  application_mode: 'nieuw',
  application_process: 'stp',
  application_segment: 'consumer',
  application_version: 3,
  application_category: 'app-activation',
};
export const STEP_RABO_SCANNER_LOGIN: ApplicationData = {
  ...APP_DATA,
  application_step_number: 3,
  application_step_name: 'rabo-scanner-login',
  application_step_type: '0',
  application_step_required: true,
};

export const EVENT_BUTTON_LOGIN: AnalyticsEventData = {
  ...APP_DATA,
  event_category: STEP_RABO_SCANNER_LOGIN.application_id,
  event_action: `${STEP_RABO_SCANNER_LOGIN.application_step_name} - ${eventClick}`,
  event_label: 'login',
};

export const EVENT_BUTTON_RANDOM_READER: AnalyticsEventData = {
  ...APP_DATA,
  event_category: STEP_RABO_SCANNER_LOGIN.application_id,
  event_action: `${STEP_RABO_SCANNER_LOGIN.application_step_name} - ${eventClick}`,
  event_label: 'random reader',
};

export const EVENT_BUTTON_HELP: AnalyticsEventData = {
  ...APP_DATA,
  event_category: STEP_RABO_SCANNER_LOGIN.application_id,
  event_action: `${STEP_RABO_SCANNER_LOGIN.application_step_name} - ${eventClick}`,
  event_label: 'help',
};

export const ANALYTICS_EVENTS = {
  STEP_RABO_SCANNER_LOGIN,
  EVENT_BUTTON_LOGIN,
  EVENT_BUTTON_RANDOM_READER,
  EVENT_BUTTON_HELP,
};
